/* Testimonials scroll arrows — injected dynamically */
document.addEventListener('DOMContentLoaded', function() {
    var section = document.querySelector('.testimonials');
    if (!section) return;
    var scroll = section.querySelector('.testimonials-scroll') || section.querySelector('.bt-grid-3');
    if (!scroll) return;
    // Если стрелки уже есть — пропускаем
    if (section.querySelector('.testimonials-arrow') || section.querySelector('.scroll-arrow')) return;
    // Оборачиваем в wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'testimonials-wrapper';
    scroll.parentNode.insertBefore(wrapper, scroll);
    wrapper.appendChild(scroll);
    // Создаём стрелки
    var left = document.createElement('button');
    left.className = 'testimonials-arrow testimonials-arrow-left';
    left.setAttribute('aria-label', 'Previous');
    left.innerHTML = '\u2039';
    left.onclick = function() { scroll.scrollBy({left: -340, behavior: 'smooth'}); };
    var right = document.createElement('button');
    right.className = 'testimonials-arrow testimonials-arrow-right';
    right.setAttribute('aria-label', 'Next');
    right.innerHTML = '\u203A';
    right.onclick = function() { scroll.scrollBy({left: 340, behavior: 'smooth'}); };
    wrapper.insertBefore(left, scroll);
    wrapper.appendChild(right);
});
